import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import {
    fetchCommunicatorHistorySuccessAction,
    fetchCommunicatorMessageSuccessAction,
} from '../actions/communicatorMessage';

type State = {
    communicatorMessage: Array<string | any> | any;
    loading: boolean;
    posting: boolean;
    errorMessage: null | any;
    pagination: any;
};
const INITIAL_STATE: State = {
    communicatorMessage: [],
    loading: false,
    posting: false,
    errorMessage: null,
    pagination: {},
};

const fetchCommunicatorMessage = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchCommunicatorMessageSuccess = (
    state: State,
    action: PayloadAction<fetchCommunicatorMessageSuccessAction>,
): State => {
    const { byId, allIds } = GENERAL_FUNCTIONS.normalizeById(
        'id',
        action.payload.body.data,
    );

    return {
        ...state,
        loading: false,
        communicatorMessage: {
            byId: byId,
            allIds: allIds,
        },
    };
};

const fetchCommunicatorMessageFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const createCommunicatorMessage = (state: State): State => {
    return {
        ...state,
        posting: true,
    };
};

const createCommunicatorMessageSuccess = (state: State): State => {
    return {
        ...state,
        posting: false,
    };
};

const createCommunicatorMessageFailed = (state: State): State => {
    return {
        ...state,
        posting: false,
    };
};

const fetchCommunicatorHistory = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const fetchCommunicatorHistorySuccess = (
    state: State,
    action: PayloadAction<fetchCommunicatorHistorySuccessAction>,
): State => {
    return {
        ...state,
        loading: false,
        communicatorMessage: action.payload.body.data,
        pagination: {
            page: action.payload.body?.page,
            limit: action.payload.body?.limit,
            totalPages: action.payload.body?.totalPages,
            count: action.payload.body?.count,
            totalCount: action.payload.body?.totalCount,
        },
    };
};
const fetchCommunicatorHistoryFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const communicatorMessage = createReducer(INITIAL_STATE, {
    [ActionTypes.FETCH_COMMUNICATOR_MESSAGE]: fetchCommunicatorMessage,
    [ActionTypes.FETCH_COMMUNICATOR_MESSAGE_SUCCESS]:
        fetchCommunicatorMessageSuccess,
    [ActionTypes.FETCH_COMMUNICATOR_MESSAGE_FAILED]:
        fetchCommunicatorMessageFailed,
    [ActionTypes.CREATE_COMMUNICATOR_MESSAGE]: createCommunicatorMessage,
    [ActionTypes.CREATE_COMMUNICATOR_MESSAGE_SUCCESS]:
        createCommunicatorMessageSuccess,
    [ActionTypes.CREATE_COMMUNICATOR_MESSAGE_FAILED]:
        createCommunicatorMessageFailed,
    [ActionTypes.FETCH_COMMUNICATOR_HISTORY]: fetchCommunicatorHistory,
    [ActionTypes.FETCH_COMMUNICATOR_HISTORY_SUCCESS]:
        fetchCommunicatorHistorySuccess,
    [ActionTypes.FETCH_COMMUNICATOR_HISTORY_FAILED]:
        fetchCommunicatorHistoryFailed,
});

export default communicatorMessage;
